"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishRFQ = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var PublishRFQ = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = props.cell, colSpan = _a.colSpan, action = _a.action, payload = _a.payload, rowSpan = _a.rowSpan;
    var styles = props.style;
    var onButtonClickedV = props.onButtonClicked;
    return ((0, jsx_runtime_1.jsx)("td", __assign({ style: styles, colSpan: colSpan, rowSpan: rowSpan }, { children: (0, jsx_runtime_1.jsx)(antd_1.Popconfirm, __assign({ title: "Are you sure edit IR and change status to approved?", onConfirm: function () { return (onButtonClickedV || lodash_1.noop)(action, payload); }, onCancel: function () { return (0, lodash_1.noop)(action, payload); }, okText: "Yes", cancelText: "No" }, { children: (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ href: "#", style: { color: '#ff312e' } }, { children: 'Publish RFQ' })) })) })));
};
exports.PublishRFQ = PublishRFQ;
